import { Money } from '@quickbit/qb-design-system';
import { useCallback } from 'react';
import { useAsync } from 'react-use';
import { fetchExchangeRate } from '../api';

const euroCurrency = 'EUR';
const usdtCurrency = 'USDT';

export const useConvertAmount = () => {
  const { value: exchangeRate } = useAsync(async () => fetchExchangeRate(), []);

  const convert = useCallback(
    (amount: Money): Money => {
      if (!exchangeRate) return amount;
      const amountNumber = amount.amount;
      const toCurrency =
        amount.currencyCode === euroCurrency ? usdtCurrency : euroCurrency;
      const newAmount =
        toCurrency === usdtCurrency
          ? amountNumber / exchangeRate
          : amountNumber * exchangeRate;
      return {
        amount: Number(newAmount.toFixed(toCurrency === euroCurrency ? 2 : 6)),
        currencyCode: toCurrency,
      };
    },
    [exchangeRate]
  );

  return convert;
};
